class AppVersion {
	constructor() {
		this.Major = 2;
		this.Minor = 1;
		this.Build = 50;
		this.Date = '10/06/2025';
	}

	getVersion() {
		return 'v ' + this.Major + '.' + this.Minor + '.' + this.Build;
	}
}
const appVersion = new AppVersion();
export default appVersion;
